import { RootStateType } from 'store/rootReducer';

export const selectToast = (state: RootStateType) => state.toast;
